"use client";

import { cn } from "cn";
import { usePathname } from "next/navigation";
import { NavLink } from "@/components/shell/nav-link";
import { mainNavItems, type NavItem, secondaryNavItems } from "@/data/routes";

export function AppSidebar({ className }: { className?: string }) {
  const pathname = usePathname();

  return (
    <aside
      className={cn(
        "no-scrollbar h-full w-56 flex-col overflow-y-auto",
        className
      )}
    >
      <nav className="flex flex-1 flex-col gap-0.5 p-3">
        {mainNavItems.map((item) => (
          <SidebarLink
            isActive={pathname === item.href}
            item={item}
            key={item.href}
          />
        ))}
      </nav>

      <div className="mt-auto flex flex-col gap-0.5 border-gray-400 border-t p-3">
        {secondaryNavItems.map((item) => (
          <SidebarLink item={item} key={item.href} />
        ))}
      </div>
    </aside>
  );
}

function SidebarLink({
  item,
  isActive,
}: {
  item: NavItem;
  isActive?: boolean;
}) {
  return (
    <NavLink
      className={cn(
        "gap-2 rounded-lg px-3 py-2 text-sm",
        "hover:bg-gray-300 hover:text-fg active:bg-gray-300",
        isActive ? "bg-gray-300 text-fg" : "text-fg-secondary"
      )}
      item={item}
    />
  );
}
